import { PreBuiltRoleAdminType } from './types';

// i18n-ignore: API service values
export const adminPreBuiltRoles: PreBuiltRoleAdminType[] = [
  'Admin',
  'Admin - Workflow',
  'Admin - Automation',
  'Admin - Workflow - Automation',
  'Administrator',
  'Owner',
];
